import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  CustomerFileSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/summary`;

export interface GetCustomerFileFullSummaryQueryPayload {
  fileId: string;
}

type GetCustomerFileFullSummaryQuery = (
  payload: GetCustomerFileFullSummaryQueryPayload,
) => Promise<BackResponse<CustomerFileSummary> | BackResponseFailure>;

export const getCustomerFileFullSummaryRequest = (
  payload: GetCustomerFileFullSummaryQueryPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getCustomerFileFullSummaryQuery: GetCustomerFileFullSummaryQuery =
  async (payload) => {
    try {
      return await executeQuery<BackResponse<CustomerFileSummary>>(
        getCustomerFileFullSummaryRequest(payload),
      );
    } catch (exception) {
      return prepareResponseFailure(exception);
    }
  };

export default getCustomerFileFullSummaryQuery;
